/*
 * AdabStars: one product type at a time + infinite scroll (owner 2026-10-04: "show only one product type at a time
 * default to shirts ... showcase ALL the unique designs on one page, as you scroll it reveals more").
 * Markup: sections/main-collection.liquid (grid [data-tv]) and sections/main-search.liquid (grid [data-iv-grid]).
 *  - The server renders the cards of the selected type on its (small, perf 2026-10-04) page. When cards continue on
 *    later pages the grid has data-next-url; the next page is fetched with the Section Rendering API (?section_id=)
 *    one page ahead of the visitor (never every page at once: each render costs the shop), repeated designs
 *    (data-as-key) are dropped and the count is corrected once the last page is in.
 *  - Cards are revealed in batches as the visitor scrolls. "Show more" button for keyboard users and for
 *    prefers-reduced-motion (no automatic loading then). Without JS every card on the page shows and the pager stays.
 *  - Type tabs ([data-tv-tabs]) are links; here they swap the product area in place (history kept), with roving
 *    focus: arrow keys / Home / End move between tabs, Enter or Space opens one.
 */
(function () {
  'use strict';
  var BATCH = 24;
  var reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var slice = function (l) { return Array.prototype.slice.call(l); };

  function sectionUrl(href, sid) {
    var u = new URL(href, location.href);
    u.searchParams.delete('section_id');
    u.searchParams.set('section_id', sid);
    return u.toString();
  }
  function cleanUrl(href) {
    var u = new URL(href, location.href);
    u.searchParams.delete('section_id');
    return u.pathname + u.search;
  }

  function initGrid(scope) {
    var grid = scope.querySelector('[data-tv], [data-iv-grid]');
    if (!grid || grid.getAttribute('data-iv-init')) return;
    grid.setAttribute('data-iv-init', '1');
    var sid = grid.getAttribute('data-section-id');
    var next = grid.getAttribute('data-next-url') || '';
    var multi = !!next;
    var more = scope.querySelector('[data-tv-more]');
    var btn = scope.querySelector('[data-tv-more-btn]');
    var status = scope.querySelector('[data-tv-status]');
    var countEl = scope.querySelector('[data-tv-count]');
    var pager = scope.querySelector('[data-tv-pager]');
    if (pager) pager.hidden = true;
    var keys = {};
    var queue = [];
    var shown = 0;
    var loading = null;
    // data-tv-batch="all": show every card at once (grouped decor view, 2026-10-04 sidebar).
    var batch = grid.getAttribute('data-tv-batch') === 'all' ? 100000 : BATCH;

    function take(card) {
      var k = card.getAttribute('data-as-key');
      if (k) {
        if (keys[k]) { if (card.parentNode) card.parentNode.removeChild(card); return false; }
        keys[k] = 1;
      }
      return true;
    }
    function total() { return grid.querySelectorAll('.product-card').length; }

    slice(grid.querySelectorAll('.product-card')).forEach(function (c) {
      if (!take(c)) return;
      if (shown < batch) { shown++; } else { c.hidden = true; queue.push(c); }
    });

    function updateCount() {
      if (!countEl || !multi) return;
      var n = total();
      var one = countEl.getAttribute('data-word-one') || 'design';
      var many = countEl.getAttribute('data-word-many') || 'designs';
      countEl.textContent = (countEl.getAttribute('data-prefix') === 'none' ? '' : 'Showing ') + n + ' ' + (n === 1 ? one : many);
      var tabCount = scope.querySelector('.tv-tab[aria-selected="true"] [data-tv-tab-count]');
      if (tabCount) tabCount.textContent = '(' + n + ')';
    }

    function update() {
      var has = queue.length > 0 || !!next;
      if (more) more.hidden = !has;
      if (status) status.textContent = has ? ('Showing ' + shown + ' of ' + total() + (next ? '+' : '')) : '';
      if (btn) btn.disabled = queue.length === 0 && !!loading;
    }

    function fetchNext() {
      if (loading) return loading;
      if (!next) return Promise.resolve();
      loading = fetch(sectionUrl(next, sid), { credentials: 'same-origin' }).then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var g = doc.querySelector('[data-tv], [data-iv-grid]');
        next = g ? (g.getAttribute('data-next-url') || '') : '';
        document.dispatchEvent(new CustomEvent('astv:page', { detail: { doc: doc } })); // as-coll-sidebar.js
        if (g) {
          slice(g.querySelectorAll('.product-card')).forEach(function (c) {
            c = document.importNode(c, true);
            if (!take(c)) return;
            c.hidden = true;
            grid.appendChild(c);
            queue.push(c);
          });
        }
        loading = null;
        if (!next) updateCount();
        update();
      }).catch(function () {
        loading = null;
        next = '';
        if (pager) pager.hidden = false; // fall back to the page links
        update();
      });
      return loading;
    }

    function revealBatch() {
      var batch = queue.splice(0, BATCH);
      batch.forEach(function (c) { c.hidden = false; });
      requestAnimationFrame(function () { batch.forEach(function (c) { c.classList.add('visible'); }); });
      shown += batch.length;
      update();
      if (queue.length < BATCH && next) fetchNext();
    }

    function nearEnd() {
      return more && !more.hidden && more.getBoundingClientRect().top < window.innerHeight + 900;
    }
    function autoMore() {
      if (reduce) return;
      if (queue.length) {
        revealBatch();
        requestAnimationFrame(function () { if (nearEnd()) autoMore(); });
      } else if (next) {
        fetchNext().then(function () { if ((queue.length || next) && nearEnd()) autoMore(); }); // a page may hold no card of this type
      }
    }

    if (btn) btn.addEventListener('click', function () {
      if (queue.length) revealBatch();
      else if (next) fetchNext().then(function more() {
        if (queue.length) revealBatch();
        else if (next) fetchNext().then(more);
      });
    });
    // Sidebar "Search in this collection" (assets/as-coll-sidebar.js): load every remaining page, then show all cards.
    grid.__tvLoadAll = function () {
      function step() {
        if (next) return fetchNext().then(step);
        var rest = queue.splice(0, queue.length);
        rest.forEach(function (c) { c.hidden = false; c.classList.add('visible'); });
        shown += rest.length;
        update();
        return Promise.resolve();
      }
      return step();
    };
    if (more && !reduce && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        if (entries.some(function (e) { return e.isIntersecting; })) autoMore();
      }, { rootMargin: '900px 0px' }).observe(more);
    }
    update();
    // One page of lookahead, so scrolling rarely waits; later pages load as the visitor nears the end.
    if (next && queue.length < BATCH) fetchNext();
  }

  function swap(href, push, focusType) {
    var grid = document.querySelector('[data-tv]');
    var area = grid && grid.closest('.main-collection');
    if (!area) { location.href = href; return; }
    document.documentElement.classList.add('tv-loading');
    fetch(sectionUrl(href, grid.getAttribute('data-section-id')), { credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.text();
    }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('.main-collection');
      if (!fresh) throw new Error('no section');
      area.innerHTML = fresh.innerHTML;
      slice(area.querySelectorAll('.reveal')).forEach(function (el) { el.classList.add('visible'); });
      if (push) history.pushState({ tv: 1 }, '', cleanUrl(href));
      init(area);
      document.documentElement.classList.remove('tv-loading');
      if (focusType) {
        var t = area.querySelector('.tv-tab[data-type="' + focusType + '"]');
        if (t) t.focus();
      }
    }).catch(function () { location.href = href; });
  }

  function initTabs(scope) {
    var list = scope.querySelector('[data-tv-tabs]');
    if (!list || list.getAttribute('data-iv-init')) return;
    list.setAttribute('data-iv-init', '1');
    var tabs = slice(list.querySelectorAll('[role="tab"]'));
    var any = false;
    tabs.forEach(function (t) {
      var sel = t.getAttribute('aria-selected') === 'true';
      t.tabIndex = sel ? 0 : -1;
      any = any || sel;
    });
    if (!any && tabs[0]) tabs[0].tabIndex = 0;
    list.addEventListener('keydown', function (e) {
      var i = tabs.indexOf(document.activeElement);
      if (i < 0) return;
      var j = null;
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') j = (i + 1) % tabs.length;
      else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') j = (i - 1 + tabs.length) % tabs.length;
      else if (e.key === 'Home') j = 0;
      else if (e.key === 'End') j = tabs.length - 1;
      else if (e.key === ' ' || e.key === 'Spacebar') { e.preventDefault(); tabs[i].click(); return; }
      if (j === null) return;
      e.preventDefault();
      tabs[j].focus();
    });
    list.addEventListener('click', function (e) {
      var t = e.target.closest('[role="tab"]');
      if (!t || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button > 0) return;
      e.preventDefault();
      if (t.getAttribute('aria-selected') === 'true') return;
      tabs.forEach(function (x) { x.setAttribute('aria-selected', x === t ? 'true' : 'false'); x.classList.toggle('active', x === t); });
      swap(t.href, true, t.getAttribute('data-type'));
    });
  }

  // Two-way filters 2026-10-05: on phones the chip and tab rows scroll sideways, so a selected chip/tab further along
  // (Bags, Jummah) was off screen. Scroll each row (not the page) so the selected one shows.
  function revealActive(scope) {
    slice(scope.querySelectorAll('.collection-filters')).forEach(function (row) {
      var a = row.querySelector('.active, [aria-selected="true"]');
      if (!a || row.scrollWidth <= row.clientWidth + 2) return;
      var r = row.getBoundingClientRect(), b = a.getBoundingClientRect();
      if (b.left >= r.left && b.right <= r.right) return;
      row.scrollLeft += b.left - r.left - Math.max(0, (r.width - b.width) / 2);
    });
  }

  function init(scope) {
    initTabs(scope);
    initGrid(scope);
    revealActive(scope);
  }

  window.ASTV = { swap: swap };

  document.addEventListener('change', function (e) {
    var s = e.target && e.target.closest && e.target.closest('[data-tv-sort]');
    if (s && s.value) location.href = s.value;
  });
  window.addEventListener('popstate', function () {
    if (document.querySelector('[data-tv]')) swap(location.href, false);
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
})();
